import "./Home.module.css";
import PrimaryNavigation from "@/reusable_sections/Header";
import PrecisionInEveryPillar from "./sections/PrecisionInEveryPillar";
import ProfessionalGearHighlights from "./sections/ProfessionalGearHighlights";
import TheBncStandard from "./sections/TheBncStandard";
import PartnerWithUs from "./sections/PartnerWithUs";
import GlobalManufacturingImpact from "./sections/GlobalManufacturingImpact";
import CommonQuestions from "./sections/CommonQuestions";
import ReadyForKickoff from "./sections/ReadyForKickoff";
import EngineeringFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <PrimaryNavigation />
      <PrecisionInEveryPillar />
      <ProfessionalGearHighlights />
      <TheBncStandard />
      <PartnerWithUs />
      <GlobalManufacturingImpact />
      <CommonQuestions />
      <ReadyForKickoff />
      <EngineeringFooter />
    </div>;
}